import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { API_URL } from "../utils/constant";
import { useCheckUser } from "../hooks/useCheckUser";
import PageLoadingOverlay from "../components/PageLoadingOverlay";

const AuthContext = createContext(null);

export const useAuth = () => {
    const auth = useContext(AuthContext);
    return auth;
}

const AuthProvider = ({children}) => {
    const {user, setUser, isLoading, checkUser} = useCheckUser();
    const [manualLoading, setManualLoading] = useState(false);
    const [requestCount, setRequestCount] = useState(0);
    const loading = manualLoading || requestCount > 0;

    useEffect(() => {
        const requestInterceptor = axios.interceptors.request.use(
            (config) => {
                if (!config?.skipGlobalLoading) {
                    setRequestCount((count) => count + 1);
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        const responseInterceptor = axios.interceptors.response.use(
            (response) => {
                if (!response?.config?.skipGlobalLoading) {
                    setRequestCount((count) => Math.max(0, count - 1));
                }
                return response;
            },
            (error) => {
                if (!error?.config?.skipGlobalLoading) {
                    setRequestCount((count) => Math.max(0, count - 1));
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.request.eject(requestInterceptor);
            axios.interceptors.response.eject(responseInterceptor);
        };
    }, []);

    const logout = () => {
        const url = API_URL + '/auth/logout';
        const localData = JSON.parse(localStorage.getItem('user'))??{};
        axios.request({
            method: "POST",
            url,
            headers: {
                'Authorization': `Bearer ${localData?.token}`
            },
        })
        .then(response => {
            console.log('logout')
            setUser(null);
            localStorage.setItem('user', '{}');
        }).catch(e => {
            console.log(e.response)
            setUser(null);
            localStorage.setItem('user', '{}');
        })


    }
    return (
        <AuthContext.Provider value={{user, setUser, logout, checkUser, loading, setLoading: setManualLoading}}>
            { !isLoading && children}
            <PageLoadingOverlay loading={loading} message="Loading..." fullScreen />
        </AuthContext.Provider>
    )

}

export default AuthProvider;
